module.exports = __webpack_public_path__ + "assets/img/find_value.b0844ad2.png";